// src/lib/scan.ts
/* Movatic WMS — util para sanitizar leituras de scanner (Zebra/teclado/câmera) */
export function sanitizeScan(raw?: string): string {
    let x = (raw ?? '').toString();

    // remove controles/saltos e espaços
    x = x.replace(/[\r\n\t]/g, '');
    x = x.replace(/\s+/g, '');

    // remove sufixos comuns do DataWedge no FINAL da string
    // (ENTER, <ENTER>, CR, <CR>, LF, <LF>, TAB, <TAB>, etc.)
    x = x.replace(/(?:<ENTER>|ENTER|<CR>|CR|\\r|<LF>|LF|\\n|<TAB>|TAB)+$/gi, '');

    // nada mais agressivo aqui (não filtramos dígitos/letras)
    return x;
}
